export default __webpack_public_path__ + "static/media/Sycamore Icons-09.e49a3b0f.svg";